// All landing page copy lives here for easy editing.

export const CTA_TEXT = "Apply For A Place";
export const SCARCITY_MICRO = "Spaces are limited for the first cohort.";

export const testimonials = [
  {
    quote:
      "Doug helped me break down solos that felt completely out of reach. He showed me how to split difficult parts into smaller chunks and practise properly. Things that used to feel impossible started to feel doable and more fun to work on.",
    name: "Greg Bulman",
    avatar: "https://customer-assets-39nsmqrw.emergentagent.net/job_guitar-technique-lab/artifacts/ko20ob0y_Greg.png",
  },
  {
    quote:
      "Thanks to Doug, I've realised that better playing is not just about learning more licks or always playing faster at all costs. I'm way happier about my playing already, and I finally know how to keep on improving now.",
    name: "Brendon Hansford",
    avatar: "https://customer-assets-39nsmqrw.emergentagent.net/job_guitar-technique-lab/artifacts/i4bm8xkb_Brendon.jpg",
  },
  {
    quote:
      "Doug helped me get out of playing the same things in my solos all the time. His approach to learning the fretboard actually just works, and it feels a lot less confusing than anything I'd tried before.",
    name: "Ron Irizarry",
    avatar: "https://customer-assets-39nsmqrw.emergentagent.net/job_guitar-technique-lab/artifacts/6vols9k6_Ron.png",
  },
  {
    quote:
      "Doug showed me a clever fast picking trick and broke it down in a way I could actually play. He made me realise that flashy lead guitar is not as out of reach as I thought.",
    name: "Adam Richards",
    avatar: "https://customer-assets-39nsmqrw.emergentagent.net/job_guitar-technique-lab/artifacts/a78ei60r_Adam.png",
  },
];

export const problemChecklist = [
  "You hate how your improvised solos sound.",
  "You've been playing for decades, but still can't play how you want.",
  "You sit down to practise and don't know what to focus on.",
  "You keep falling back on the same licks and patterns.",
  "Your technique falls apart when you try to play faster.",
];

export const outcomes = [
  "Turn what you hear in your head into what you actually play.",
  "Build solid technique that you don't have to think about while soloing.",
  "Break out of the same few licks and finally solo with freedom across the whole neck.",
  "Improvise confidently, outlining chords instead of playing randomly.",
  "Get a clear routine, so you always know exactly what to practise.",
  "Feel confident enough to finally play with other musicians.",
  "Actually feel something when you play, not just hit the \u201cright\u201d notes.",
];

export const coachCredentials = [
  {
    title: "Background",
    text: "Self-taught, then formally trained through an HND and a degree at Brighton Institute of Modern Music.",
  },
  {
    title: "Stage Experience",
    text: "15+ years playing fully professionally across the UK and Middle East.",
  },
  {
    title: "Teaching Experience",
    text: "Years of teaching lead guitar, both in person and over Zoom.",
  },
  {
    title: "Full Time Guitar",
    text: "Founded the channel in 2022. Now over 20K subscribers and 1M+ views.",
  },
];

export const offerFeatures = [
  { title: "Technique Development", text: "Learn what correct technique actually feels like, and how to shift gradually into better playing habits." },
  { title: "Fretboard Freedom", text: "Move freely across the whole neck, so you're never stuck in the same box with the same handful of licks again." },
  { title: "Improvisation Development", text: "Solo confidently using space, tension and release, and chord outlining, instead of guessing your way through and hoping it works." },
  { title: "Musical Phrasing", text: "Make your solos sound like part of the song, not scales or exercises." },
  { title: "Creative Expression", text: "Turn the ideas you hear in your head into things you can actually play, instead of your hands limiting what you can do." },
  { title: "Real-World Playing", text: "Build the confidence to finally play with other musicians, not just alone in your room." },
];

export const deliveryFeatures = [
  { title: "Group Calls", text: "Live weekly calls to work through what's holding your playing back in real time." },
  { title: "Video Feedback", text: "Personal feedback and check-ins on your own playing, so you always know what to fix next." },
  { title: "Practice Files", text: "PDF and Guitar Pro tabs for everything taught in the program, so nothing gets forgotten." },
  { title: "Practice Roadmap", text: "Full access to the Shred Routine Roadmap, the structured practice system that feeds directly into every weekly session." },
  { title: "Accountability", text: "Built-in structure that keeps you practising consistently, instead of letting it slip once life gets busy." },
  { title: "Final Solo", text: "A recorded solo project at the end, so your progress is something you can actually hear." },
];

export const bonuses = [
  { title: "Lifetime Access", text: "All future on-demand content added to the program is yours to keep for good." },
  { title: "Recording Training", text: "Watch how I write and record my own solos, plus a full breakdown of my recording setup and gear." },
];

export const forYou = [
  "You're an intermediate rock guitarist who has been playing for years but still feels stuck.",
  "You want to improvise better solos and develop solid technique.",
  "You keep falling back into the same old patterns when you solo.",
  "You want to improve your technique, timing, control, and confidence.",
  "You want hands-on help instead of another pile of random lessons.",
];

export const notForYou = [
  "You're a complete beginner who is still learning basic chords and strumming.",
  "You're looking for a magic trick that fixes everything overnight.",
  "You only want to collect more licks without changing how you practise.",
];

export const faqs = [
  {
    q: "Is this for me if I'm not an advanced player?",
    a: "Yes. This is built for intermediate rock guitarists who can already play some licks, scales, riffs, and solos, but feel stuck when they try to turn that into fast, fluid lead playing. You do not need to be a shred monster. You just need to be able to play basic lead guitar and be willing to follow a structured practice plan.",
  },
  {
    q: "What style of guitar is this for?",
    a: "This is mainly for rock lead guitarists who want to play faster, more fluid, more expressive solos. If your heroes are players like Nuno, Van Halen, Vai, Gilbert, or classic 80s rock players, you're in the right place.",
  },
  {
    q: "What if I've already learned loads of licks and scales?",
    a: "Good. That means you already have the raw material. What's usually missing isn't more licks. It's a system for turning technique, fretboard knowledge, and phrasing into actual soloing ability.",
  },
  {
    q: "Is this just a course, or do I get feedback?",
    a: "This is not just a folder of videos. The point of the program is structure, feedback, and accountability. You'll get weekly live group coaching calls, personal video feedback on your own playing, and regular accountability check-ins, so you always know what to work on next instead of guessing.",
  },
  {
    q: "How much time do I need to practise?",
    a: "You'll get the best results if you can practise consistently, ideally 30\u201360+ minutes a day, most days. You don't need unlimited free time. In fact, this is designed for busy players who need to stop wasting practice time on random exercises, licks, and YouTube rabbit holes.",
  },
];

export const media = {
  vslThumbnail:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_guitar-technique-lab/artifacts/803zvqvk_VSL%20Thumbnail.jpg",
  coach:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_guitar-technique-lab/artifacts/thoqnhfq_Doug%20promo%20july%202026.webp",
  vimeoId: "1210488926",
};
